import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "2acfa7e2-9cba-4566-a465-967692cb6a0f",
  publicId: "25",
  name: "Architectural design",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, task01],
};

export default lesson;
